import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable, postConstruct } from 'mana-syringe';
import { Node as X6Node } from '@antv/x6';
import isBoolean from 'lodash/isBoolean';
import { XFlowNodeCommands } from '../constant';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { ReactShape } from '@antv/x6-react-shape';
export var NsUpdateNode;
(function (NsUpdateNode) {
    NsUpdateNode.command = XFlowNodeCommands.UPDATE_NODE;
    NsUpdateNode.hookKey = 'updateNode';
    NsUpdateNode.XFlowNodeSetOptions = { overwrite: true };
    NsUpdateNode.NODE_WIDTH = 200;
    NsUpdateNode.NODE_HEIGHT = 40;
})(NsUpdateNode || (NsUpdateNode = {}));
let UpdateNodeCommand = 
/** 节点更新命令 */
class UpdateNodeCommand {
    constructor() {
        this.setNodeConfig = (x6Node, nodeConfig, options) => {
            x6Node.setData(nodeConfig, options);
            x6Node.setPosition((nodeConfig === null || nodeConfig === void 0 ? void 0 : nodeConfig.x) || 0, (nodeConfig === null || nodeConfig === void 0 ? void 0 : nodeConfig.y) || 0);
            x6Node.setSize((nodeConfig === null || nodeConfig === void 0 ? void 0 : nodeConfig.width) || NsUpdateNode.NODE_WIDTH, (nodeConfig === null || nodeConfig === void 0 ? void 0 : nodeConfig.height) || NsUpdateNode.NODE_HEIGHT);
            x6Node.angle((nodeConfig === null || nodeConfig === void 0 ? void 0 : nodeConfig.angle) || 0, {
                absolute: true,
            });
            if (isBoolean(nodeConfig === null || nodeConfig === void 0 ? void 0 : nodeConfig.visible)) {
                x6Node.setVisible(nodeConfig === null || nodeConfig === void 0 ? void 0 : nodeConfig.visible);
            }
            // SVG 元素更新label
            if (!(x6Node instanceof ReactShape) && !!x6Node.getAttrByPath('text/text')) {
                x6Node.setAttrByPath('text/text', nodeConfig.label);
            }
            // 支持nodeAttrs
            if (nodeConfig.attrs) {
                x6Node.setAttrs(nodeConfig.attrs);
            }
            // 更新ports
            if (Array.isArray(nodeConfig.ports)) {
                x6Node.setPropByPath('ports/items', nodeConfig.ports, Object.assign({ rewrite: true }, options));
            }
        };
        this.getNodeConfig = (x6Node) => {
            const data = x6Node.getData();
            const position = x6Node.getPosition();
            const size = x6Node.getSize();
            return Object.assign(Object.assign(Object.assign({}, data), position), size);
        };
        this.getNodeCell = (x6Graph, handlerArgs) => {
            const { nodeConfig, setNodeConfig } = handlerArgs;
            let nodeId = '';
            if (setNodeConfig && setNodeConfig.node && typeof setNodeConfig.node === 'string') {
                nodeId = setNodeConfig.node;
            }
            else if (nodeConfig && nodeConfig.id && typeof nodeConfig.id === 'string') {
                nodeId = nodeConfig.id;
            }
            if (nodeId) {
                return x6Graph === null || x6Graph === void 0 ? void 0 : x6Graph.getCellById(nodeId);
            }
            if (setNodeConfig && setNodeConfig.node instanceof X6Node) {
                return setNodeConfig.node;
            }
        };
        this.getNextNodeConfig = (handlerArgs, x6Node) => __awaiter(this, void 0, void 0, function* () {
            if (handlerArgs && handlerArgs.setNodeConfig && handlerArgs.setNodeConfig.callback) {
                const nodeData = this.getNodeConfig(x6Node);
                return handlerArgs.setNodeConfig.callback(nodeData);
            }
            return handlerArgs.nodeConfig;
        });
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const { args, hooks: runtimeHook } = this.ctx.getArgs();
            const hooks = this.ctx.getHooks();
            const result = yield hooks.updateNode.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const { options = NsUpdateNode.XFlowNodeSetOptions } = handlerArgs;
                const graph = yield this.ctx.getX6Graph();
                const x6Node = this.getNodeCell(graph, handlerArgs);
                const nextNodeConfig = yield this.getNextNodeConfig(handlerArgs, x6Node);
                this.setNodeConfig(x6Node, nextNodeConfig, options);
                return {
                    nodeConfig: nextNodeConfig,
                    nodeCell: x6Node,
                };
            }), runtimeHook);
            this.ctx.setResult(result);
            return this;
        });
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.ctx.isUndoable) {
                yield this.execute();
            }
            return this;
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    isUndoable() {
        return this.ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], UpdateNodeCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UpdateNodeCommand.prototype, "init", null);
UpdateNodeCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsUpdateNode.command.id },
    })
    /** 节点更新命令 */
], UpdateNodeCommand);
export { UpdateNodeCommand };
//# sourceMappingURL=node-update.js.map